import React from "react";
import { t } from "../i18n";
import { If } from "./If";

export class SiSelect extends React.Component<{
  showLabel?: boolean;
  size?: string;
  label?: string;
  className?: string;
  style?: { [id: string]: string };
}> {
  render(): React.ReactNode {
    const {
      size,
      children,
      className = "",
      label = "",
      showLabel = true,
      style = {}
    } = this.props;
    return (
      <si-select class={className} style={style}>
        <If predicate={label !== "" && showLabel}>
          <label>{t(label)}</label>
        </If>

        <div className={`form-select ${size === "large" ? "large" : ""}`}>
          {children}

          <div className="form-select-arrow">
            <i className="material-icons">keyboard_arrow_down</i>
          </div>
        </div>
      </si-select>
    );
  }
}
